import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FetchedData, genFetchedData } from 'redux/fetchedData';

export interface SideMenuState {
  uploadDSPData: FetchedData<any>;
  sendToGridData: FetchedData<any>;
  sendMassCreativeAddTask: FetchedData<any>;
}

const initialState: SideMenuState = {
  uploadDSPData: genFetchedData(null),
  sendToGridData: genFetchedData(null),
  sendMassCreativeAddTask: genFetchedData(null)
};

const SideMenuSlice = createSlice({
  name: 'SideMenu',
  initialState,
  reducers: {
    setUploadDspData(
      state,
      action: PayloadAction<SideMenuState['uploadDSPData']>,
    ) {
      state.uploadDSPData = action.payload;
    },
    setSendToGridData(
      state,
      action: PayloadAction<SideMenuState['sendToGridData']>,
    ) {
      state.sendToGridData = action.payload;
    },
    setSendMassCreativeAddTask(
      state,
      action: PayloadAction<SideMenuState['sendMassCreativeAddTask']>,
    ) {
      state.sendMassCreativeAddTask = action.payload;
    }
  },
});

export const fetchUploadDsp = createAction('SideMenu/fetchUploadDsp');
export const fetchSendCreoToGrid = createAction('SideMenu/fetchSendCreoToGrid');
export const fetchSendMassCreativeAddTask= createAction('SideMenu/fetchSendMassCreativeAddTask');

export const { setUploadDspData, setSendToGridData, setSendMassCreativeAddTask } = SideMenuSlice.actions;

export const sideMenuReducer = SideMenuSlice.reducer;
